import request from '@/utils/request'

/// 登录
export function getSelf () {
    return request({
      url: '/member/self',
      method: 'get',
    })
}

export function getSignedApp(id, isPlist, config) {
  var requestConfig = Object.assign({
    url: '/sign_ipa/' + id,
    method: 'get'
  }, config || {})

  if (isPlist) {
    requestConfig.url = '/sign_ipa/' + id + "?include=plist_url"
  }
  return request(requestConfig)
}
